module.exports = __webpack_public_path__ + "static/noun_755386-waterfront.26abdc58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/noun_755386-waterfront.svg
// module id = 454
// module chunks = 35783957827783